export { DemoComponent } from './lib/demo-component/demo-component';
export { IconPreview } from './lib/icon/icon-preview';
export { EntityMenu } from './lib/entity-menu';
export { Head } from './lib/head';
